import { Button, Col, Row } from 'react-bootstrap';
import TextEditor from './text-editor';
import { cmsString } from '../../../utils/string';
import { useEffect, useState } from 'react';
import APICallService from '../../../api/apiCallService';
import { CSM_PAGE } from '../../../api/apiEndPoints';
import { success } from '../../../Global/toast';
import { cmsToast } from '../../../utils/toast';
import Loader from '../../../Global/loader';
const TermsConditions = () => {
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [data, setData] = useState<any>([]);
  const [postData, setPostData] = useState<any>('');
  useEffect(() => {
    (async () => {
      setFetchLoading(true);
      await fetchPolicyData();
      setFetchLoading(false);
    })();
  }, []);
  const fetchPolicyData = async () => {
    setLoading(true);
    let apiService = new APICallService(CSM_PAGE.GET_TERMS_CONDITIONS);
    let response: any = await apiService.callAPI();
    if (response) {
      setData(response);
    }
    setLoading(false);
  };
  const saveTermsConditions = async () => {
    setLoading(true);
    let apiService = new APICallService(CSM_PAGE.POST_TERMS_CONDITIONS, {
      content: postData,
    });
    let response: any = await apiService.callAPI();
    if (response) {
      success(cmsToast.updateTerms);
      setData(response);
    }
    setLoading(false);
  };
  return (
    <>
      <Row className="align-items-center">
        <Col
          md
          className="align-self-center mb-5"
        >
          <h1 className="fs-22 fw-bolder">{cmsString.termsTitle}</h1>
        </Col>
        {fetchLoading ? (
          <div className="d-flex justify-content-center m-4">
            <Loader loading={fetchLoading} />
          </div>
        ) : (
          <>
            <TextEditor
              data={data}
              setData={setData}
              onChange={(val: any) => {
                setPostData(val);
              }}
            />
            <Col
              xs="auto"
              className="pt-7"
            >
              <Button
                variant="primary"
                size="lg"
                onClick={saveTermsConditions}
                disabled={loading}
              >
                {!loading && (
                  <span className="indicator-label fs-16 fw-bolder">
                    {cmsString.save}
                  </span>
                )}
                {loading && (
                  <span
                    className="indicator-progress fs-16 fw-bolder"
                    style={{ display: 'block' }}
                  >
                    Please wait...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </Button>
            </Col>
          </>
        )}
      </Row>
    </>
  );
};
export default TermsConditions;
